import { render, staticRenderFns } from "./lightbox-submissions.vue?vue&type=template&id=2d9481b8&scoped=true&"
import script from "./lightbox-submissions.vue?vue&type=script&lang=js&"
export * from "./lightbox-submissions.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-submissions.vue?vue&type=style&index=0&id=2d9481b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9481b8",
  null
  
)

export default component.exports